export const FETCH_SIEVE_SIZE_REQUEST = 'FETCH_SIEVE_SIZE_REQUEST';
export const FETCH_SIEVE_SIZE_SUCCESS = 'FETCH_SIEVE_SIZE_SUCCESS';
export const FETCH_SIEVE_SIZE_FAILURE = 'FETCH_SIEVE_SIZE_FAILURE';

export const ADD_SIEVE_SIZE_REQUEST = 'ADD_SIEVE_SIZE_REQUEST';
export const ADD_SIEVE_SIZE_SUCCESS = 'ADD_SIEVE_SIZE_SUCCESS';
export const ADD_SIEVE_SIZE_FAILURE = 'ADD_SIEVE_SIZE_FAILURE';

export const UPDATE_SIEVE_SIZE_REQUEST = 'UPDATE_SIEVE_SIZE_REQUEST';
export const UPDATE_SIEVE_SIZE_SUCCESS = 'UPDATE_SIEVE_SIZE_SUCCESS';
export const UPDATE_SIEVE_SIZE_FAILURE = 'UPDATE_SIEVE_SIZE_FAILURE';

export const DELETE_SIEVE_SIZE_REQUEST = 'DELETE_SIEVE_SIZE_REQUEST';
export const DELETE_SIEVE_SIZE_SUCCESS = 'DELETE_SIEVE_SIZE_SUCCESS';
export const DELETE_SIEVE_SIZE_FAILURE = 'DELETE_SIEVE_SIZE_FAILURE';

export const SIEVE_SIZE_FORM_ERROR = 'SIEVE_SIZE_FORM_ERROR';
export const SIEVE_SIZE_FORM_SUCCESS = 'SIEVE_SIZE_FORM_SUCCESS';
export const SET_SIEVE_SIZE_EDIT = 'SET_SIEVE_SIZE_EDIT';
export const CLEAR_SIEVE_SIZE_EDIT = 'CLEAR_SIEVE_SIZE_EDIT'; 